<template>
  <b-sidebar :visible="isOpen" bg-variant="white" sidebar-class="sidebar-lg" shadow 
      :backdrop="false" no-header width="45em"
      @hidden="() => $store.commit('h_map_store/TOGGLE_SIDEBAR', false)">

    <template #default="{ hide }">

      <div class="loading_page" v-if="loader">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>

      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0"><slot name="title"></slot></h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide"/>
      </div>

      <slot></slot>

    </template>
  </b-sidebar>
</template>

<script>

import { BSidebar, } from 'bootstrap-vue'
import { OrbitSpinner } from 'epic-spinners'
import { computed } from '@vue/composition-api'
import store from '@/store'

export default {
  name: 'MapSideBar',
  components: {OrbitSpinner, BSidebar},
  props: ['isOpen'],
  setup() {

    const loader = computed(() => store.state.h_map_store.sideBarIndicator)

    return {
      loader
    }
  }
}
</script>

<style scoped>

</style>
